import { BadgeTypes } from "./types";
import { Badge } from "./Badge";
import { capitalize } from "../../../../helpers/string/capitalize";

const feedPropsByType: Record<
  string,
  {
    type: BadgeTypes;
    customTitle?: string;
    isDynamicState?: boolean;
  }
> = {
  failed: { type: "error" },
  noData: { type: "error", customTitle: "Could not fetch data" }, //the only used for not just the feed

  warning: { type: "warning" },
  noHistory: { type: "warning", customTitle: "History not available" },

  "in progress": { type: "neutral", isDynamicState: true },
  fetching: { type: "neutral", isDynamicState: true },
  noFeed: { type: "neutral", customTitle: "No feed imported yet" },

  successful: { type: "success" },
};

export const StateToBadge = (
  feedType: keyof typeof feedPropsByType,
  dynamicTitle?: string,
) => {
  const { type, customTitle, isDynamicState } = feedPropsByType[feedType];
  return (
    <Badge
      type={type}
      title={capitalize(dynamicTitle ?? customTitle ?? feedType)}
      className={isDynamicState ? "animate-pulse" : undefined}
      isStateBadge={true}
    />
  );
};
